import Button from "../Button";
import Modal from "@components/_Revamp/Modal";
import React from "react";
import { styled } from "@linaria/react";
import { useHistory } from "react-router-dom";
import { ROUTE_PATH } from "@static/route-paths";
import { css } from "@linaria/core";
import { SCREEN_SIZE } from "@static/screen-size";

const ModalCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const ModalHeader = styled.div`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 140%;
  text-align: center;
  color: #434343;
  flex: none;
  order: 0;
  flex-grow: 1;
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    font-size: 28px;
  }
`;

const ModalDescription = styled.div`
  margin-top: 16px;
  max-width: 350px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  text-align: center;
  color: #8a8988;
  margin-bottom: 64px;
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    font-weight: 600;
  }
`;

const ButtonContainers = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  gap: 24px;
`;
const buttonCss = css`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 140%;
  width: 180px;
  @media screen and (max-width: 470px) {
    width: 100%;
  }
`;

const IdleTimoutClass = css`
  z-index: 1000;
`;

export default function ShieldStarterIdleTimeout({
  showIdleModal,
  setShowIdleModal,
  onClickContactUs,
}: any) {
  const onclose = () => {
    setShowIdleModal(false);
  };
  return (
    <Modal className={IdleTimoutClass} show={showIdleModal} onClose={onclose}>
      <ModalCard>
        <ModalHeader>Need help with your quote?</ModalHeader>
        <ModalDescription>
          You&apos;ve been inactive for a while. If all is good, go back to
          continue with your quote or contact us for help.
        </ModalDescription>
        <ButtonContainers>
          <Button
            className={buttonCss}
            bgColor="white"
            textColor="#883E89"
            hoverBgColor="white"
            hoverTextColor="#883E89"
            label={"Go back"}
            onClick={() => {
              setShowIdleModal(false);
            }}
          />
          <Button
            className={buttonCss}
            label={"Contact us"}
            onClick={() => {
              setShowIdleModal(false);
              onClickContactUs();
            }}
          />
        </ButtonContainers>
      </ModalCard>
    </Modal>
  );
}
